import { HostConfig, MountPoint, Volume } from 'docker-types';

import { EnvironmentSecuritySettings } from '@/react/portainer/environments/types';

/**
 * Checks if the container uses a feature that security settings restrict for regular users
 */
export function usesRestrictedFeature(
  securitySettings: EnvironmentSecuritySettings,
  hostConfig: HostConfig = {},
  mounts: Array<MountPoint> = [],
  volumes: Array<Volume> = []
): boolean {
  return (
    (!securitySettings.allowPrivilegedModeForRegularUsers &&
      !!hostConfig.Privileged) ||
    (!securitySettings.allowHostNamespaceForRegularUsers &&
      hostConfig.PidMode === 'host') ||
    (!securitySettings.allowDeviceMappingForRegularUsers &&
      !!hostConfig.Devices?.length) ||
    (!securitySettings.allowSysctlSettingForRegularUsers &&
      Object.keys(hostConfig.Sysctls ?? {}).length > 0) ||
    (!securitySettings.allowSecurityOptForRegularUsers &&
      !!hostConfig.SecurityOpt?.length) ||
    (!securitySettings.allowContainerCapabilitiesForRegularUsers &&
      (!!hostConfig.CapAdd?.length || !!hostConfig.CapDrop?.length)) ||
    (!securitySettings.allowBindMountsForRegularUsers &&
      (mounts.some((mount) => isBindMountType(mount.Type)) ||
        volumes.some(isBindBackedVolume) ||
        !!hostConfig.VolumesFrom?.length))
  );
}

function isBindMountType(type?: string) {
  return type === 'bind' || type === 'npipe';
}

function isBindBackedVolume({ Driver, Options }: Volume) {
  const isLocalDriver = !Driver || Driver.toLowerCase() === 'local';

  return Object.entries(Options ?? {}).some(([key, value]) => {
    const option = key.toLowerCase();

    return (
      (option === 'type' && value.toLowerCase() === 'bind') ||
      (option === 'o' &&
        value
          .split(',')
          .map((token) => token.trim().toLowerCase())
          .some((token) => token === 'bind' || token === 'rbind')) ||
      (option === 'device' && isLocalDriver && value !== '')
    );
  });
}
